import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import { Col, Navbar, Nav } from "react-bootstrap";
import { MydnaLogoMobileDark, MydnaLogoDark } from "../../Icons/logo";
import { MdSearch } from "react-icons/md";
import { FaRegUserCircle } from "react-icons/fa";
import { HiOutlineEmojiHappy } from "react-icons/hi";
import { AiOutlineLogout } from "react-icons/ai";
import { RiNotification3Line } from "react-icons/ri";
import DropdownMenu from "./dropdown";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

import { EmployerContext } from "../../Store/EmployerContext";

import "./mainMenu.sass";
import { menuHeaderTranslate } from "../../i18n/translatedMessages";

const MainMenuEmployee = ({ clearOption }) => {
  const handleRecharge = () => {
    window.location.reload(false);
  };

  const { store } = useContext(EmployerContext);

  const [value, setValue] = useState(store.language === "ES" ? "Español" : "Português");
  const handleSelect = (e) => {
    setValue(e);
  };

  const { actions } = useContext(EmployerContext);

  return (
    <Navbar className="main-menu-candidate bg-md-light" sticky="top">
      <Col className="main-menu-col col-md-auto" xs={12}>
        <Navbar.Brand href="/candidate">
          <div className="desktop">
            <MydnaLogoDark size={140} />
          </div>
          <div className="mobile">
            <MydnaLogoMobileDark size={22} />
          </div>
        </Navbar.Brand>

        <Nav className="main-menu-mobile">
          <Link to="/app">
            <HiOutlineEmojiHappy />
          </Link>
          <Link to="/app">
            <FaRegUserCircle />
          </Link>
          <Link to="/app">
            <MdSearch />
          </Link>
          <Link to="/app">
            <RiNotification3Line />
          </Link>
          <Link to="/app">
            <AiOutlineLogout />
          </Link>
        </Nav>

        <Nav className="main-menu-nav-candidate">
          <div>
            {window.location.pathname === "/candidate" ? (
              <button className="btn candidateMenuNavItem p-0 color-white" onClick={handleRecharge}>
                {menuHeaderTranslate.homepage}
              </button>
            ) : (
              <Link
                className="candidateMenuNavItem color-white"
                to="/candidate"
                onClick={clearOption}
              >
                {menuHeaderTranslate.homepage}
              </Link>
            )}
            <Link to="/candidate/opportunities" className="candidateMenuNavItem color-white mx-4">
              {menuHeaderTranslate.vacancies}
            </Link>
          </div>
          <div className="d-flex justify-content-xl-between"></div>

          <div className="bar-active-menu"></div>
        </Nav>
      </Col>
      <Col className="col-user-dropdown d-flex justify-content-end pe-5">
        <DropdownButton
          className="dropdown-main-menu"
          id="dropdown-basic-button"
          size="sm"
          variant="secondary"
          menuVariant="dark"
          title={value}
          onSelect={handleSelect}
        >
          <Dropdown.Item eventKey="Español" onClick={() => actions.setLanguage("ES")}>
            Español
          </Dropdown.Item>
          <Dropdown.Item eventKey="Português" onClick={() => actions.setLanguage("PT-BR")}>
            Português
          </Dropdown.Item>
        </DropdownButton>
      </Col>
      <div className="col-md-auto col-user-dropdown d-flex justify-content-end me-2">
        <DropdownMenu />
      </div>
    </Navbar>
  );
};
export default MainMenuEmployee;
